const filters = document.querySelector("[data-filters]")

// Convert object to query string helper
const obj2QueryString = obj => {
	return Object.keys(obj)
		.map(key => {
			return encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])
		})
		.join("&")
}

const getFilterData = filterElements =>
	Array.from(filterElements).reduce((i, filter) => {
		i[filter.name] = filter.value
		return i
	}, {})

// Ajax new content, and replace existing content
const getContent = filterData => {
	const oldListingContent = document.querySelector("[data-filtered-content]")
	const loader = document.createElement("div")
	loader.setAttribute("class", "loader")
	oldListingContent.prepend(loader)
	// Update current filters
	const newLocation =
		location.origin +
		location.pathname +
		"?" +
		obj2QueryString(filterData())
	fetch(newLocation)
		.then(response => {
			history.pushState("", "", newLocation)
			return response.text()
		})
		.then(data => {
			const parser = new DOMParser()
			const htmlResponse = parser.parseFromString(data, "text/html")
			const newListingContent = htmlResponse.documentElement.querySelector(
				"[data-filtered-content]"
			)

			oldListingContent.innerHTML = newListingContent.innerHTML
		})
		.catch(error => {
			console.log("🤡")
			console.log(error)
		})
}

// Loop through provided elements and init listeners
const initListeners = (filterElements, filterData) => {
	Array.prototype.forEach.call(filterElements, element => {
		element.addEventListener(
			"change",
			event => {
				if (event.target.tagName.toLowerCase() === "input") {
					getContent(() => {
						const i = []
						i[element.name] = element.value
						return i
					})
					return
				}

				getContent(filterData)
			},
			false
		)
	})
}

const initFilters = filters => {
	if (!filters) return

	// Check for filters inside our wrapper
	const filterElements = filters.querySelectorAll(`select, input[type=text]`)

	if (filterElements.length === 0) return

	// Get current filters in a format ready for zlFetch
	const filterData = () => getFilterData(filterElements)

	// Create listeners for each select, and fire ajax function
	initListeners(filterElements, filterData)
}

initFilters(filters)
